import { useTranslation } from 'react-i18next';

import { AnsweredStatus } from '../../../puck/report/utils/surveys/conditions';
import { Text } from '../../atoms/text/text';
import { ThresholdBar, ThresholdBarProps } from '../threshold-bar/threshold-bar';

interface IThresholdBarOverviewProps extends Omit<ThresholdBarProps, 'showAnnotations'> {
  readonly answeredStatus: AnsweredStatus;
  readonly renderMeasureText: React.FunctionComponent;
  readonly appearance?: ThresholdBarProps['appearance'];
}

export const ThresholdBarOverview = ({
  answeredStatus,
  appearance,
  renderMeasureText: RenderMeasureText,
  ...props
}: IThresholdBarOverviewProps) => {
  const { t } = useTranslation();

  const displayText = (() => {
    switch (answeredStatus) {
      case AnsweredStatus.COMPLETED:
        return `${props.value} / ${props.maxValue}`;
      case AnsweredStatus.NOT_COMPLETED:
        return t('report.questionNotCompleted');
      case AnsweredStatus.NOT_SHOWN:
        return t('report.conditionNotShown');
      case AnsweredStatus.SKIPPED:
        return t('report.conditionSkipped');
      default:
        ((value: never): never => {
          throw new Error(`Unhandled case: ${value}`);
        })(answeredStatus);
    }
  })();

  return (
    <div className="flex flex-col my-1 lg:flex-row flex-wrap items-center">
      <ThresholdBar
        {...props}
        appearance={appearance}
        className="h-[6px] lg:w-3/6"
        disabled={answeredStatus !== AnsweredStatus.COMPLETED}
        showAnnotations={false}
      />
      <div className="flex items-start">
        <Text className="mx-1 text-xs text-nowrap pt-1">{displayText}</Text>
        <Text className="mx-1 text-md">
          <RenderMeasureText />
        </Text>
      </div>
    </div>
  );
};
